import { DateTime } from "luxon";

/**
 * Builds a search string for the base month with a +/- month window.
 * Defaults to 2 months before and 2 months after.
 *
 * Example: For November 2025 with 2 months before and 2 months after, the search string will be:
 * "after:2025-09-01 before:2026-01-01"
 *
 * @param baseMonth - The base month to build the range from.
 * @param options.monthsBefore - Number of months before the base month start.
 * @param options.monthsAfter - Number of months after the base month start.
 * @returns The search string for the month range.
 */
export const buildBeforeAfterSearchString = (
  baseMonth: DateTime,
  {
    monthsBefore = 2,
    monthsAfter = 2,
  }: { monthsBefore?: number; monthsAfter?: number } = {
    monthsBefore: 2,
    monthsAfter: 2,
  }
) => {
  const start = baseMonth
    .startOf("month")
    .minus({ months: monthsBefore })
    .toISODate();
  const end = baseMonth
    .startOf("month")
    .plus({ months: monthsAfter })
    .toISODate();
  return `after:${start} before:${end}`;
};
